import React from 'react';

const Header = ({ currentScreen }) => {
  // Get location and mineral from screen name
  const getLocationDisplay = () => {
    if (currentScreen.includes('DRC')) return 'DRC';
    return 'RWANDA';
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-4">
        <h1 className="text-2xl font-bold">MineSmart</h1>
        <span className="text-gray-400">| LIVE OPERATIONS</span>
        <span className={`px-4 py-1 rounded-full text-sm font-medium ${
          currentScreen.includes('DRC') ? 'bg-blue-500' : 'bg-white text-gray-900'
        }`}>
          {getLocationDisplay()} 
        </span>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-gray-400">{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} at {new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span>
        <span className="px-4 py-1 bg-green-500 rounded-full text-sm font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-white rounded-full"></span>
          LIVE
        </span>
      </div>
    </div>
  );
};

export default Header;